<template>
  <header
    id="header-homepage"
    :key="campaign ? 'campaign' : 'fallback'"
    class="grid grid-cols-12 overflow-x-hidden"
    :class="{
      'bg-app-green-200 mb-20 mt-[-80px] pt-[80px]': campaign,
      'pt-6 xl:pt-12': !campaign,
    }"
    data-component="HeaderHome"
  >
    <template v-if="campaign">
      <div class="col-span-full row-start-1 row-end-2 lg:row-end-6 lg:col-end-13 lg:col-start-7">
        <figure v-if="campaign.image" class="-mx-12 h-full sm:ml-0">
          <MoleculePicture class="block w-full h-full" :image="campaign.image" />
        </figure>
      </div>
      <div class="col-end-12 col-start-2 row-end-5 row-start-3 lg:col-end-7 lg:row-end-auto xl:row-start-2">
        <div class="flex flex-col items-start py-4 pr-3 md:pb-16 md:pr-8 lg:py-8 lg:pr-6">
          <h1 class="inline-flex py-3 text-3xl 2xl:text-6xl font-black uppercase md:py-3 md:text-5xl md:font-bold lg:py-3 lg:text-4xl xl:py-3 xl:text-5xl leading-[1.2]">
            {{ campaign.title }}
          </h1>
          <div v-if="campaign.introduction" class="inline-flex pb-10 md:pb-8">
            <div class="text-[1em] leading-[1.4] font-normal md:text-lg" v-html="campaign.introduction" />
          </div>
          <div class="flex flex-col sm:flex-row sm:w-full gap-4">
            <AtomButton v-if="campaign.primaryButtonLabel && campaign.primaryButtonUrl" class="!shadow-none px-4" button-type="primary" :url="campaign.primaryButtonUrl"
              >{{ campaign.primaryButtonLabel }} <AtomIconArrowRight class="flex ml-4 mr-2 w-3 h-3"
            /></AtomButton>
            <AtomButton
              v-if="campaign.secondaryButtonLabel && campaign.secondaryButtonUrl"
              class="uppercase !shadow-none px-4"
              button-type="quaternary"
              :url="campaign.secondaryButtonUrl"
              >{{ campaign.secondaryButtonLabel }} <AtomIconArrowRight class="flex ml-4 mr-2 w-3 h-3"
            /></AtomButton>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="col-span-full row-end-6 row-start-1 sm:col-end-13 sm:col-start-7 lg:col-end-13">
        <figure v-if="image" class="-mx-12 2xl:mr-20 sm:ml-0 sm:mr-4 lg:mr-10 xl:mr-12">
          <MoleculePicture class="block w-full" :image="image" />
        </figure>
      </div>
      <div class="col-end-12 col-start-1 row-end-5 row-start-3 sm:col-end-8 sm:row-end-auto xl:row-start-2">
        <div class="flex flex-col items-start">
          <h1
            class="inline-flex p-4 text-2xl 2xl:text-6xl font-black leading-none bg-app-lime rounded-r-2xl uppercase md:p-6 md:text-3xl md:font-bold lg:p-8 lg:text-4xl xl:p-12 xl:text-5xl"
          >
            {{ title }}
          </h1>
          <div v-if="introduction" class="inline-flex mr-12 p-4 bg-white rounded-br-2xl md:p-6 lg:p-8 xl:p-12">
            <div class="2xl:text-5xl text-lg font-black leading-none uppercase md:text-xl md:font-bold lg:text-2xl xl:text-4xl" v-html="introduction" />
          </div>
        </div>
      </div>
    </template>
  </header>
</template>

<script setup lang="ts">
interface Props {
  title: string
  introduction?: string
  image?: object
  campaign?: object
}

defineProps<Props>()
</script>
